import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { PlannerMapDataElement, PlannerPoi } from 'components/common/types/Planner.types';
import { getCurrentLineId } from 'store/dealManagement/selectors/getCurrentLineId';
import { useCartoSelectionTool } from './useCartoSelectionTool';
import { FurnitureItem } from './useFurniture.types';
import { usePlannerData } from '../context/usePlannerData';

export type UsePlannerMapResult = {
  clusterAssetsData: PlannerMapDataElement[];
  lassoFurnitures: FurnitureItem[];
  poiData: PlannerPoi[];
  handleViewportChange: (data: PlannerMapDataElement[]) => void;
};

export const usePlannerMap = (): UsePlannerMapResult => {
  const { poiResult, clusterAssetsData, handleViewportChange } = usePlannerData();
  const currentLineId = useSelector(getCurrentLineId);
  const { getLassoFurnitures } = useCartoSelectionTool(currentLineId);

  const lassoFurnitures = useMemo(() => {
    return getLassoFurnitures(clusterAssetsData);
  }, [clusterAssetsData, getLassoFurnitures]);

  return {
    clusterAssetsData,
    lassoFurnitures,
    poiData: poiResult.poiData,
    handleViewportChange,
  };
};
